import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { NotificationDialog } from './NotificationDialog';

import * as DialogActions from './state/actions';
import * as DialogSelectors from './state/selectors';

class DialogManager extends React.Component {
  static displayName = 'NotificationDialogManager';
  static propTypes = {
    dialog: PropTypes.object,
    showDialog: PropTypes.bool,
  };

  onDialogOkClick = () => {
    const { notificationDialogOk } = this.props;

    notificationDialogOk();
  };

  onDialogCancelClick = () => {
    const { notificationDialogCancel } = this.props;

    notificationDialogCancel();
  };

  render() {
    const { dialog, showDialog } = this.props;

    return (
      <NotificationDialog
        {...dialog}
        showDialog={showDialog}
        onOkClick={this.onDialogOkClick}
        onCancelClick={this.onDialogCancelClick}
      />
    );
  }
}

const mapStateToProps = state => ({
  dialog: DialogSelectors.getDialog(state),
  showDialog: DialogSelectors.getShowDialog(state),
});

const mapDispatchToProps = {
  notificationDialogCancel: DialogActions.notificationDialogCancel,
  notificationDialogOk: DialogActions.notificationDialogOk,
};

const NotificationDialogManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(DialogManager);

export { NotificationDialogManager };



// WEBPACK FOOTER //
// ./src/components/dialogs/NotificationDialogManager.js